import connect from 'react-redux/es/connect/connect';

import BookingSummary from '../components/BookingSummary';
import { updateCartDiscount } from '../actions/cart';

const mapStateToProps = (state, ownProps) => ({
    customer: state.user.customer,
    user: state.user.user,
    cartItems: ownProps.cartItems ? ownProps.cartItems : state.cart.cartItems,
    booker: ownProps.booker ? ownProps.booker : state.cart.booker,
    discount: ownProps.discount ? ownProps.discount : state.cart.discount,
    isAgent: state.user.user?.role === 'agent'
});

const mapDispatchToProps = dispatch => ({
    updateCartDiscount: newDiscount => {
        dispatch(updateCartDiscount(newDiscount));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingSummary);
